"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OTHER_OBLIGATIONS = exports.DOMESTIC_OBLIGATIONS = exports.HSA_OBLIGATIONS = exports.UNION_OBLIGATIONS = exports.LOAN_OBLIGATIONS = exports.VOLUNTARY_OBLIGATIONS = exports.MANDATORY_OBLIGATIONS = exports.LIFE_INSURANCE = exports.VISION_INSURANCE = exports.DENTAL_INSURANCE = exports.MEDICAL_INSURANCE = exports.SOCIAL_SECURITY = exports.MEDICARE = exports.OTHER_TAXES = exports.STATE_TAXES = exports.FEDERAL_TAXES = void 0;
exports.FEDERAL_TAXES = "federal_taxes";
exports.STATE_TAXES = "state_taxes";
exports.OTHER_TAXES = "other_taxes";
exports.MEDICARE = "medicare";
exports.SOCIAL_SECURITY = "social_security";
exports.MEDICAL_INSURANCE = "medical_insurance";
exports.DENTAL_INSURANCE = "dental_insurance";
exports.VISION_INSURANCE = "vision_insurance";
exports.LIFE_INSURANCE = "life_insurance";
exports.MANDATORY_OBLIGATIONS = "mandatory_obligations";
exports.VOLUNTARY_OBLIGATIONS = "voluntary_obligations";
exports.LOAN_OBLIGATIONS = "loan_obligations";
exports.UNION_OBLIGATIONS = "union_obligations";
exports.HSA_OBLIGATIONS = "hsa_obligations";
exports.DOMESTIC_OBLIGATIONS = "domestic_obligations";
exports.OTHER_OBLIGATIONS = "other_obligations";